import ConditionContainer from "../../../components/pages/other/Condition";

const Condition = () => {
  return <ConditionContainer />;
};

export default Condition;
